import { render, staticRenderFns } from "./UiButton.vue?vue&type=template&id=7785f467"
import script from "./UiButton.vue?vue&type=script&lang=js"
export * from "./UiButton.vue?vue&type=script&lang=js"
import style0 from "./UiButton.vue?vue&type=style&index=0&id=7785f467&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./UiButton.vue?vue&type=custom&index=0&blockType=docs&lang=md"
if (typeof block0 === 'function') block0(component)

export default component.exports